import type { HasCurrent } from "../Current/HasCurrent.type"
import type { Entity } from "./index"
import { waterEntityTypeIdList } from "./waterEntityTypeIdList"
import type { WaterEntityUnion } from "./WaterEntityUnion.type"

export type EntityWaterWithCurrent = WaterEntityUnion & HasCurrent

/**
 * requirements
 * - A "water" entity is one that which a shoal entity will "dip" into.
 * 
 * @param entity 
 * @returns boolean
 */
export default function isEntityWaterWithCurrent(entity: Entity): entity is EntityWaterWithCurrent {
  return (entity as HasCurrent).current && waterEntityTypeIdList.includes(entity.etype_id)
}